// extracted by mini-css-extract-plugin
export default {"arrow":"PhotoSlider_arrow__C2YRj","left":"PhotoSlider_left__JJ9eK","right":"PhotoSlider_right__qPTvR","fullscreen":"PhotoSlider_fullscreen__IkUhB"};